var map = {
	"./date-format.de-CH.json": 994,
	"./date-format.de-DE.json": 995,
	"./date-format.en-CA.json": 996,
	"./date-format.en-GB.json": 997,
	"./date-format.en-IN.json": 998,
	"./date-format.en-ME.json": 999,
	"./date-format.en-US.json": 1000,
	"./date-format.es-EM.json": 1001,
	"./date-format.es-ES.json": 1002,
	"./date-format.fr-BE.json": 1003,
	"./date-format.fr-CA.json": 1004,
	"./date-format.fr-CH.json": 1005,
	"./date-format.nl-BE.json": 1006,
	"./date-format.nl-NL.json": 1007,
	"./date-format.pl-PL.json": 1008,
	"./date-format.pt-BR.json": 1009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 993;